import React, { memo } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
// Constants
import { RoutesList } from 'routes';
import { BrowserStorageKeys } from 'constants/browserStorage';

const { CRM_SIGN_IN, SSO_SIGN_IN } = RoutesList;

const NotFoundPage = () => {
    const isCRMSignIn = localStorage.getItem(BrowserStorageKeys.isCRMSignIn) === 'true';

    if (isCRMSignIn) {
        return <Redirect to={`/${CRM_SIGN_IN.path}`} />;
    }

    return <Redirect to={`/${SSO_SIGN_IN.path}`} />;
};

NotFoundPage.propTypes = {
    titleKey: PropTypes.string.isRequired,
};

export default memo(NotFoundPage);
